<template>
  <div>
    <div class="main_left">
      <div class="index-buygift">
        <img src="../assets/index/btn-buygift-top.gif" alt="" />
        <!-- 左边得布局 -->
        <a class="btn-buygift buy subb" @click="goBuy">
          <img :src="getByIcon()" alt="" />
          <!-- buy多语言变化 -->
        </a>
      </div>
      <div class="index-transfer">
        <img src="../assets/index/btn-transfer-top.gif" alt="" />
        <a class="btn-transfer subb" @click="goGift">
          <img :src="getExchageIcon()" alt="" />
          <!-- 握手多语言变化 -->
        </a>
      </div>

      <div class="side-info-wrap">
        <div class="side-info-gradient">
          <div class="dw-motion">
            <img src="../assets/index/yao.gif" alt="" />
          </div>
          <div class="xiazai">
            <div class="xia_left">
              <div class="">
                <a
                  href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282"
                  target="_blank"
                  class="xia_left_top"
                >
                  <img src="../assets/index/qrcode-ios.png" />
                </a>
                <a
                  href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282"
                  target="_blank"
                >
                  <div class="dianji">
                    {{ $t("index.xiaZai") }}<i class="el-icon-caret-right"></i>
                  </div>
                </a>
                <a
                  href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282"
                  target="_blank"
                  class="xia_left_center"
                >
                  <img src="../assets/index/ma.png" alt="" />
                </a>
                <a
                  href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282"
                  target="_blank"
                  class="xia_left_btm"
                >
                  <img src="../assets/index/ma2.png" alt="" />
                </a>
              </div>
            </div>
            <div class="xia_right subb">
              <div class="" @click="goDown">
                <a class="xia_left_top">
                  <img src="../assets/index/qrcode-akp.png" />
                </a>
                <a>
                  <div class="dianji">
                    {{ $t("index.xiaZai") }}<i class="el-icon-caret-right"></i>
                  </div>
                </a>
                <a class="xia_left_center"
                  ><img src="../assets/index/apk.png" alt=""
                /></a>
              </div>
            </div>
          </div>

          <div class="fb_wrap_container">
            <div class="fb-wrap" style="padding:0.2rem">
              <a href="https://t.me/+F8X9lq36hC81M2Jl" target="_blank">
                <img
                  src="../assets/index/liaotian.png"
                  style="width:7.375rem;height:3.125rem;object-fit:contain;"
                  alt=""
                />
              </a>
            </div>
            <div class="fb-wrap" style="padding:0.2rem;margin: 0 0 0 0.2rem;">
              <a
                href="https://www.facebook.com/profile.php?id=100095166211902"
                target="_blank"
              >
                <img
                  src="../assets/index/facebook.png"
                  style="width: 7.375rem;
    height: 3.125rem;
    object-fit: contain;"
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Login-pop ref="LoginPop"></Login-pop>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      langtext: "en" //默认英文
    };
  },
  created() {
    this.showAll();
    this.changeIcon();
    //  var h= localStorage.getItem("lang");
    //  if(h){
    //   this.langtext =h
    //  }
  },
  mounted() {
    this.$nextTick(() => {
      this.changeIcon();
    });
  },
  computed: {
    //获取STORE里isApp
    ...mapState({
      isApp(state) {
        return state.isApp;
      },
      hasLogin(state) {
        return state.hasLogin;
      }
    })
  },
  methods: {
    //交换
    getExchageIcon() {
      if (this.langtext == "en") {
        return require("../assets/index/gift_en.png");
      } else if (this.langtext == "zh") {
        return require("../assets/index/gift_zh.png");
      } else if (this.langtext == "es") {
        //西班牙
        return require("../assets/index/gift_es.png");
      } else if (this.langtext == "pt") {
        //葡萄牙
        return require("../assets/index/gift_pt.png");
      }
    },

    getByIcon() {
      if (this.langtext == "en") {
        return require("../assets/index/buy_en.png");
      } else if (this.langtext == "zh") {
        return require("../assets/index/buy_zh.png");
      } else if (this.langtext == "es") {
        //西班牙
        return require("../assets/index/buy_es.png");
      } else if (this.langtext == "pt") {
        //葡萄牙
        return require("../assets/index/buy_pt.png");
      }
    },
    showAll() {
      var langNum = localStorage.getItem("lang");
      // console.log('langNum',langNum)
      if (langNum == "zh") {
        this.lang = 3;
      }
      if (langNum == "en") {
        this.lang = 4;
      }
      // console.log('this.lang',this.lang)
      // console.log('---123--',this.newsList);
    },
    changeIcon() {
      this.langtext = localStorage.getItem("lang");
    },
    goDown() {
      this.$router.push("/Down");
    },
    goBuy() {
      if (this.hasLogin == "0") {
        this.$router.push("/Buy");
      }
      if (this.hasLogin != "0") {
        this.$refs.LoginPop.showLogin();
        this.$store.commit("setActive", -1);
      }
    },
    goGift() {
      if (this.hasLogin == "0") {
        this.$router.push("/Gift");
      }
      if (this.hasLogin != "0") {
        this.$refs.LoginPop.showLogin();
        this.$store.commit("setActive", -1);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.fb_wrap_container {
  display: flex;
}
.main {
  width: 75rem;
  padding-bottom: 1.25rem;
  /* display: block; */
  /* height: 59.375rem; */
  overflow: auto;
  overflow-x: hidden;
  overflow-y: hidden;

  /* border: 0.0625rem solid aqua; */
  margin: 0 auto;
  margin-top: 14.375rem;
}

.content {
  width: 100%;
  // background: #ad0000
  //   url("../../assets/index/bg-pc-head.jpg") center top
  //   no-repeat;
  background-size: 100% auto;
}

.dw-motion img {
  width: 15.375rem;
  height: 3.75rem;
}

.main_left {
  width: 25%;
  float: left;
}

.index-buygift {
  width: 17.5rem;
  /* margin: 0 auto; */
  display: block;
}

.index-buygift img {
  display: block;
  height: auto;
  width: 100%;
}

.btn-buygift {
  background-size: 100%;
  display: block;
  width: 100%;
  margin-top: -0.25rem;
}

.btn-buygift img {
  display: block;
  height: auto;
  width: 100%;
}

.index-transfer {
  width: 17.5rem;
  /* margin:  0 auto; */
  display: block;
  margin-top: 0.625rem;
}

.index-transfer img {
  display: block;
  height: auto;
  width: 100%;
}

.btn-transfer {
  background-size: 100%;
  display: block;
  width: 100%;
  margin-top: -0.25rem;
}

.btn-transfer img {
  display: block;
  height: auto;
  width: 100%;
}

.side-info-wrap {
  width: 16.5625rem;
  /* margin:  0 auto; */
  margin-top: 0.625rem;
  background: #c15402;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#baa30b),
    to(#c15402)
  );
  background-image: linear-gradient(180deg, #baa30b, #c15402);
  border: solid 0.1875rem #dfc166;
  border-radius: 0.9375rem;
  -webkit-box-shadow: 0 0 0.125rem #714c01 inset, 0 0 0.125rem #714c01 inset;
  box-shadow: 0 0 0.125rem #714c01 inset, 0 0 0.125rem #714c01 inset;
  padding: 0.3125rem;
}

.side-info-gradient {
  background-image: linear-gradient(180deg, #ebdf46 0%, #cf8e08 50%, #d4841d);
  border-radius: 0.625rem;
  padding: 0.625rem 0 0.625rem 0;
}

// .qrcodeBtn-wrap {
// }

.xiazai {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.xia_left {
  width: 50%;
  margin-top: 0.3125rem;
}

.xia_right {
  width: 50%;
  margin-top: 0.3125rem;
}

.xia_left_top img {
  width: 7rem;
  height: 7rem;
}

.dianji {
  color: black;
  border: 0.0625rem solid black;
  margin: 0.3125rem 0.3125rem;
  background-color: rgb(46, 216, 0);
  padding: 0.3125rem 0;
  font-weight: 600;
  border-radius: 0.3125rem;
  border-bottom: 0.1875rem solid black;
  text-align: center;
}

.el-icon-caret-right {
  font-size: 0.9375rem;
}

.xia_left_center img {
  width: 5.9375rem;
  height: 1.9375rem;
}

.xia_left_btm img {
  width: 5.9375rem;
  height: 1.9375rem;
}

// .fbBtn_wrap{
//       margin: 0 auto;
//       width: 90%;
//       background-image: linear-gradient(180deg, #f0d34c, #cf9e35);
//       background: #f0d24c;
//       padding: 1.125rem 0;
//       margin-top: 0.625rem;
//       border-radius:0.125rem;
//       color: black;
// }

.fbBtn_wrap,
.fbBtn_wrap::after {
  //  padding: 16px 20px;
  //  font-size: 18px;

  margin: 0 auto;
  width: 90%;
  padding: 1.125rem 0;
  margin-top: 0.625rem;
  border-radius: 0.125rem;
  color: black;
  background: linear-gradient(45deg, transparent 5%, #f0d34c 5%);
  border: 0;
  //  color: #fff;
  letter-spacing: 3px;
  line-height: 1;
  box-shadow: 6px 0px 0px #cf9e35;
  outline: transparent;
  position: relative;
}

.fbBtn_wrap::after {
  --slice-0: inset(50% 50% 50% 50%);
  --slice-1: inset(80% -6px 0 0);
  --slice-2: inset(50% -6px 30% 0);
  --slice-3: inset(10% -6px 85% 0);
  --slice-4: inset(40% -6px 43% 0);
  --slice-5: inset(80% -6px 5% 0);
  content: "Telegram";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: #ffffff;
  background: linear-gradient(
    45deg,
    transparent 3%,
    #00e6f6 3%,
    #00e6f6 5%,
    #f5ce20 5%
  );
  text-shadow: -3px -3px 0px #cf9e35, 3px 3px 0px #00e6f6;
  clip-path: var(--slice-0);
}

.fbBtn_wrap:hover::after {
  animation: 1s glitch;
  animation-timing-function: steps(2, end);
}

@keyframes glitch {
  0% {
    clip-path: var(--slice-1);
    transform: translate(-20px, -10px);
  }

  10% {
    clip-path: var(--slice-3);
    transform: translate(10px, 10px);
  }

  20% {
    clip-path: var(--slice-1);
    transform: translate(-10px, 10px);
  }

  30% {
    clip-path: var(--slice-3);
    transform: translate(0px, 5px);
  }

  40% {
    clip-path: var(--slice-2);
    transform: translate(-5px, 0px);
  }

  50% {
    clip-path: var(--slice-3);
    transform: translate(5px, 0px);
  }

  60% {
    clip-path: var(--slice-4);
    transform: translate(5px, 10px);
  }

  70% {
    clip-path: var(--slice-2);
    transform: translate(-10px, 10px);
  }

  80% {
    clip-path: var(--slice-5);
    transform: translate(20px, -10px);
  }

  90% {
    clip-path: var(--slice-1);
    transform: translate(-10px, 0px);
  }

  100% {
    clip-path: var(--slice-1);
    transform: translate(0);
  }
}
</style>
